import dayjs from 'dayjs';
import type {ICalAlarmData, ICalEventData} from 'ical-generator';
import ical, {
  ICalAlarmType,
  ICalEventBusyStatus,
  ICalEventClass,
  ICalEventRepeatingFreq,
  ICalWeekday,
} from 'ical-generator';

import {DayOfTheWeek} from '../util/DayOfTheWeek';
import type {ScheduleExporterExportParams} from './ScheduleExporter';

export default function generateCalendarFile(
  params: ScheduleExporterExportParams,
) {
  const {
    now,
    schedule,
    projectName,
    domain,
    language,
    notifyBeforeInSeconds,
    supportGroupUrl,
    supportGroupName,
    supportGroupId,
    timezone,
    address,
  } = params;
  const $now = dayjs(now).tz(timezone);
  const calendar = ical({
    prodId: {
      company: projectName,
      product: domain,
      language,
    },
    url: supportGroupUrl,
    x: [
      {key: 'X-WR-CALNAME', value: supportGroupName},
      {
        key: 'X-WR-RELCALID',
        value: `supportGroup_${supportGroupId.toString(10)}`,
      },
    ],
  });

  for (const record of schedule) {
    const $start = $now
      .day(record.day)
      .hour(record.start.hour)
      .minute(record.start.minute)
      .second(0)
      .millisecond(0);
    const $end = $start.add(record.duration, 'minute');

    calendar.createEvent({
      id: `supportGroupMeeting_${record.id}@${domain}`,
      sequence: record.sequence,
      timezone,
      stamp: dayjs(record.updatedAt).tz(timezone),
      start: $start,
      end: $end,
      repeating: {
        freq: ICalEventRepeatingFreq.WEEKLY,
        byDay: DAY_MAP[record.day as DayOfTheWeek],
      },
      alarms: [
        {
          type: ICalAlarmType.display,
          relatesTo: 'START',
          trigger: notifyBeforeInSeconds,
          description: `Группа "${supportGroupName}" скоро начнёт собрание`,
        } satisfies ICalAlarmData,
      ],
      busystatus: ICalEventBusyStatus.BUSY,
      summary: supportGroupName,
      location: address,
      class: ICalEventClass.CONFIDENTIAL,
    } satisfies ICalEventData);
  }

  return calendar.toString();
}

const DAY_MAP = {
  [DayOfTheWeek.Monday]: ICalWeekday.MO,
  [DayOfTheWeek.Tuesday]: ICalWeekday.TU,
  [DayOfTheWeek.Wednesday]: ICalWeekday.WE,
  [DayOfTheWeek.Thursday]: ICalWeekday.TH,
  [DayOfTheWeek.Friday]: ICalWeekday.FR,
  [DayOfTheWeek.Saturday]: ICalWeekday.SA,
  [DayOfTheWeek.Sunday]: ICalWeekday.SU,
};
